import { registerSW } from 'virtual:pwa-register'
import { toast } from 'sonner'

/**
 * Đăng ký service worker. Chạy ngay lúc nạp module — đây là TÁC DỤNG PHỤ CỐ Ý,
 * không phải sơ suất.
 *
 * Trước đây file này bọc phần đăng ký trong `export function setupPwa()` rồi
 * gọi từ main.tsx. Rollup tree-shake mất cả module: giá trị trả về của
 * `registerSW()` không ai dùng nên nó coi lời gọi là vô hại và bỏ đi. Hậu quả
 * là bản build không hề đăng ký service worker, và Chrome vì thế không bao giờ
 * mời cài — đúng cái lỗi mà thay đổi này sinh ra để sửa.
 *
 * Nên giữ ở tầng module và nhập bằng `import './lib/pwa'`.
 *
 * KHÔNG bọc trong `if (!import.meta.env.DEV)`: repo này có `NODE_ENV=development`
 * ngay dòng đầu của `.env`, mà Vite đọc file đó, nên `import.meta.env.DEV` vẫn
 * là `true` ngay cả trong `vite build --mode production`. Khối lệnh vì thế trở
 * thành mã chết và bị bỏ đi — service worker không bao giờ được đăng ký.
 * Không cần cờ này nữa: `devOptions.enabled: false` đã khiến `registerSW` chỉ
 * là hàm rỗng khi chạy dev.
 *
 * Service worker là một trong bốn điều kiện Chrome đòi để cho cài ứng dụng
 * (cùng HTTPS, manifest có start_url, và icon 192/512).
 *
 * Dùng `registerType: 'prompt'` (xem vite.config.ts) chứ không tự cập nhật
 * ngầm: đây là app đối soát tiền. Đang xem dở một bảng kê mà trang tự nạp lại
 * thì mất ngữ cảnh và dễ đọc nhầm số. Hỏi rồi mới nạp.
 */
/**
 * Màn chưa đăng nhập (đăng nhập, mã email, đăng ký, quên / đặt lại mật khẩu, văn bản pháp lý): không có gì đang làm
 * dở để mất → có bản mới thì nạp luôn, khỏi hỏi. Thiếu cái này, trang đăng nhập mở từ trước khi deploy cứ chạy bản
 * cũ dù bấm F5 (service worker giữ bản cũ tới khi bấm "Tải lại") — 21/10/2026 admin NPP đăng nhập đúng mật khẩu mà
 * đứng im ở màn đăng nhập, vì bản cũ chưa có khu Quản trị NPP.
 */
const PUBLIC_PATHS = ['/login', '/2fa', '/signup', '/forgot-password', '/reset-password', '/terms', '/privacy']
const onPublicPage = () => PUBLIC_PATHS.some((p) => location.pathname === p || location.pathname.startsWith(p + '/'))

/** Tab mở lâu không tự biết có bản mới: hỏi máy chủ mỗi 30 phút và mỗi lần quay lại tab. */
const CHECK_EVERY_MS = 30 * 60_000

let updateWaiting = false

/** Có bản mới đang chờ thì nạp ngay — màn Đăng nhập gọi khi mở (vd. vừa đăng xuất, toast "Tải lại" bị bỏ qua). */
export function applyUpdateIfWaiting(): void {
  if (updateWaiting) void updateSW(true)
}

const updateSW = registerSW({
  onNeedRefresh() {
    updateWaiting = true
    if (onPublicPage()) {
      void updateSW(true)
      return
    }
    toast('Đã có bản cập nhật ShopTrack', {
      duration: Infinity,
      action: { label: 'Tải lại', onClick: () => void updateSW(true) },
    })
  },
  onRegisteredSW(_url, registration) {
    if (!registration) return
    const check = () => {
      if (navigator.onLine) registration.update().catch(() => {})
    }
    setInterval(check, CHECK_EVERY_MS)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check()
    })
  },
  onRegisterError(err) {
    // Không chặn app: thiếu service worker thì chỉ mất khả năng cài và chạy
    // ngoại tuyến, mọi thứ còn lại vẫn dùng bình thường.
    console.error('[pwa] không đăng ký được service worker', err)
  },
})
